import { Component, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-template-document',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateDocumentComponent {
    @Input() url: SafeResourceUrl;
    @Input() isPDF: boolean;
    @Input() titulo: string;
}
